import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import DataChip from 'module/staff-management/components/DataChip'
import DataTable from 'module/leave/pages/leaveAllocationImport/components/DataTable'
import CloseWarning from 'module/leave/pages/leaveAllocationImport/components/CloseWarning'

import { useMutation, useQueryClient } from 'react-query'

// API
import { postSendLeaveBulkImport } from 'services/api/modules/leave/bulkImport'
import AdxButton from 'components/custom/AdxButton'

const LeaveAllocationTable = (props) => {
  const queryClient = useQueryClient()
  const [pageStatus, setPageStatus] = useState('CHECK_TABLE')

  const navigate = useNavigate()

  const staffData = props?.state?.staffData

  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  const mutation = useMutation(postSendLeaveBulkImport, {
    onSuccess: (response) => {
      queryClient.invalidateQueries('staffListData')
      navigate('/app/management-centre/company-management/leave')
    },
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
        setPageStatus('ERROR')
      } else {
        console.log(error)
        setPageStatus('ERROR')
      }
    },
  })

  const handleConfirmInvite = () => {
    if (staffData?.errors_count === 0) {
      mutation.mutate({ data: staffData?.data })
      setPageStatus('CONFIRMATION')
    } else {
      alert('Please fix the following errors')
    }
  }

  const handleInviteStaff = () => {
    setPageStatus('SUCCESSFUL_REQUEST')
  }

  const returnPage = () => {
    navigate(-1)
  }

  const CustomHeader = () => {
    return (
      <>
        <Box
          sx={{
            py: 1,
            px: 4,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 1,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Typography variant="h4">Import Staff's Leave Allocation</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '10%' }}></Box>
          <CloseWarning />
        </Box>
      </>
    )
  }

  if (pageStatus === 'CONFIRMATION') {
    return (
      <AdxInfoModal
        open={true}
        muiIcon="group_add"
        iconColor="alternate.main"
        title={`Staffs data is being imported`}
        subtitle={`Please wait for a few minutes as the data is currently updating`}
        modalWidth="500px"
      ></AdxInfoModal>
    )
  }

  if (pageStatus === 'SUCCESSFUL_REQUEST') {
    return (
      <AdxInfoModal
        open={true}
        muiIcon="error"
        iconColor="warning.main"
        title={`Proceed to import leave balance and allocation?`}
        subtitle={`Leave balance and allocation will be imported once confirmed.`}
        modalWidth="500px"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={handleConfirmInvite}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={() => navigate(-1)}
      >
        {/* <Box sx={{ display: 'flex', width: '100%', columnGap: 1 }}>
          <AdxButton
            variant={'outlined'}
            sx={{ width: 1 / 3 }}
            onClick={() => navigate(-1)}
            fullWidth
          >
            Cancel
          </AdxButton>
          <AdxButton
            variant={'contained'}
            sx={{ width: 2 / 3 }}
            onClick={handleConfirmInvite}
            fullWidth
          >
            Confirm
          </AdxButton>
        </Box> */}
      </AdxInfoModal>
    )
  }

  if (pageStatus === 'ERROR') {
    return (
      <AdxInfoModal
        open={true}
        muiIcon="error"
        iconColor="error.main"
        title={`There is some issue while importing!`}
        subtitle={`Please try importing again later.`}
        modalWidth="500px"
        footerButtons
        firstBtnLabel={'Back to main page'}
        firstBtnHandle={() => navigate('/app/management-centre/company-management/leave')}
      ></AdxInfoModal>
    )
  }

  return (
    <AdxFormModal
      open={true}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      disableEscapeKeyDown
      disableAutoFocus
      sx={{
        '&.MuiModal-root': { overflowY: 'auto' },
        paddingY: '20px',
      }}
      sxModal={{
        minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '1000px' },
        width: { xs: 'calc(100vw - 30px)', lg: 'calc(100vw - 1500px)' },
      }}
      customHeader={<CustomHeader />}
    >
      <>
        {pageStatus === 'CHECK_TABLE' && (
          <Box
            sx={{
              width: '100%',
              minHeight: '300px',

              display: 'flex',
              flexDirection: 'column',
              rowGap: 2,
            }}
          >
            <Box
              sx={{
                width: 1,
                rowGap: 1,
                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography variant="body2" color="dark-gray-text.main">
                  Step 3
                </Typography>

                <Typography mr={1} variant="body2" color="light-gray-text.main">
                  Confirm the uploaded details. Then, click "Import" to proceed.
                </Typography>
                <Typography mr={1} variant="body2" color="error.main">
                  You will not be able to proceed if errors are present in the table.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'flex-start',
                  rowGap: 0.5,
                }}
              >
                <DataChip
                  sx={{ mr: 2 }}
                  color="info.main"
                  content={`${staffData && staffData?.row_count} data found`}
                />
                <DataChip
                  color="error.main"
                  content={`${staffData && staffData?.errors_count} ${
                    staffData?.errors_count > 1 ? 'errors' : 'error'
                  } found`}
                />
              </Box>
            </Box>
            <Box>
              <Box
                sx={{
                  width: '100%',
                  height: '45px',
                  backgroundColor: 'gray-background.main',
                  display: 'flex',
                  py: 1,
                  px: 3,
                  alignItems: 'center',
                  overflow: 'auto',
                }}
              >
                <Box
                  sx={{
                    minWidth: '150px',
                  }}
                  width={1 / 6}
                >
                  <Typography variant="body1" color="dark-gray-text.main">
                    ID
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '150px' }} width={1 / 6}>
                  <Typography variant="body1" color="dark-gray-text.main">
                    Staff Name
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '150px' }} width={1 / 8}>
                  <Typography align="center" variant="body1" color="dark-gray-text.main">
                    Leave Policy
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '150px', pl: 4 }} width={1}>
                  <Typography variant="body1" color="dark-gray-text.main">
                    Remarks
                  </Typography>
                </Box>
              </Box>
              <Box>
                <DataTable staffData={staffData} />
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                flexDirection: 'row',
                alignItems: 'center',

                width: '100%',
                height: '50px',
                columnGap: 1,
              }}
            >
              <AdxButton
                variant={'outlined'}
                onClick={returnPage}
                sx={{ width: { xs: 1 / 2, sm: 1 / 4 } }}
              >
                Re-upload Leave Template
              </AdxButton>
              <AdxButton
                variant={'contained'}
                onClick={handleInviteStaff}
                disabled={staffData && staffData?.errors_count !== 0 ? true : false}
                sx={{ width: { xs: 1 / 2, sm: 2 / 5 } }}
              >
                Import Data
              </AdxButton>
            </Box>
          </Box>
        )}
      </>
    </AdxFormModal>
  )
}

export default LeaveAllocationTable
